<template>
  <v-combobox v-model="combobox" :items="items" :label="label" :rules="rules" :item-text="itemText"
    :item-value="itemValue" :disabled="disabled" :multiple="multiple" outlined dense :chips="chips" :color="color">
  </v-combobox>
</template>

<script>
  export default {
    name: "RyouCombobox",
    props: {
      label: {
        type: String,
        required: false,
        default: "",
      },
      value: {
        type: Object,
        required: false,
        default: () => { }
      },
      rules: {
        type: Array,
        required: false,
        default: () => [],
      },
      color: {
        type: String,
        required: false,
        default: "",
      },
      items: {
        type: Array,
        required: true,
        default: () => [],
      },
      itemText: {
        type: String,
        required: false,
      },
      itemValue: {
        type: String,
        required: false,
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false,
      },
      multiple: {
        type: Boolean,
        required: false,
        default: false,
      },
      chips: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data() {
      return {};
    },
    computed: {
      combobox: {
        get() {
          console.log(this.value);
          return this.value;
        },
        set(val) {
          this.$emit("input", val);
        },
      },
    },
  };
</script>

<style>
</style>